/**
 * Returns the singular or plural form of a word based on the count
 * @param count - The number to check for pluralization
 * @param singular - The singular form of the word
 * @param plural - The plural form of the word
 * @returns The appropriate form based on the count
 */
export const pluralize = (
  count: number,
  singular: string,
  plural: string,
): string => (count === 1 ? singular : plural);
